import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'alarmType' })
export class AlarmTypePipe implements PipeTransform {

  readonly severityMap = {
    0:  'Other',
    1:  'Communications Alarm',
    2:  'Quality of Service Alarm',
    3:  'Processing Error Alarm',
    4:  'Equipment Alarm',
    5:  'Environmental Alarm',
    6:  'Integrity Violation',
    7:  'Operational Violation',
    8:  'Physical Violation',
    9:  'Security Service or Mechanism Violation',
    10: 'Time Domain Violation'
  };

  transform(severityId: number): string {
    return this.severityMap[severityId];
  }
}
